import { BaseApi } from 'Core/api/BaseApi'

export class Api extends BaseApi {
  getProducts = async fields => {
    const defaultResponse = { products: [], total_count: 0, total_pages: 0, current_page: 0, seo: { title: '', description: '' } }

    try {
      const response = await Api.get('/products_list', fields, process.env.NEXT_PUBLIC_WEB_SHOP_API_HOST)

      const body = response?.body

      if (body && Array.isArray(body.products) && typeof body.current_page === 'number' && typeof body.total_pages === 'number' &&
        typeof body.total_count === 'number' && body.seo && body.seo.title && body.seo.description
      ) {
        return body
      }

      return defaultResponse
    } catch (e) {
      defaultResponse.error = e

      return defaultResponse
    }
  }

  getPromoProducts = async fields => {
    const defaultResponse = { products: [], totalCount: 0, totalPages: 0, currentPage: 0, seo: { title: '', description: '' } }

    try {
      const response = await Api.get('/promo_product_list', fields, process.env.NEXT_PUBLIC_WEB_SHOP_API_HOST)

      const body = response?.body

      if (body && Array.isArray(body.products) && typeof body.currentPage === 'number' && typeof body.totalPages === 'number' &&
        typeof body.totalCount === 'number' && body.seo && body.seo.title && body.seo.description
      ) {
        return body
      }

      return defaultResponse
    } catch (e) {
      defaultResponse.error = e

      return defaultResponse
    }
  }
}
